import React, {useState} from "react"
import Flex from "@irati/ui/src/Flex"
import {CustomReward, CustomRewardStatus} from "@irati/types"
import {Body, H2, H4} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {SETTINGS_CUSTOM_REWARDS_EDIT} from "../../../routes/routeConfig"
import Toggle from "@irati/ui/src/FormItem/Toggle"
import teamName from "@irati/identity/utils/team/teamName"
import {Hr} from "@irati/ui/src/Layout"
import {useUpdateCustomRewardStatusMutation} from "@irati/custom-reward/hooks"
import {useTheme} from "@irati/ui/src/global/useTheme"
import GenericModal from "@irati/ui/src/GenericModal"

interface Props {
  customReward: CustomReward
}
const CustomRewardItem = (props: Props) => {
  const {customReward} = props
  const intl = useIntl()
  const theme = useTheme()
  const [showPreview, setShowPreview] = useState(false)
  const [updateStatus] = useUpdateCustomRewardStatusMutation({
    variables: {
      uuid: customReward.uuid,
      status: customReward.status === CustomRewardStatus.Active ? CustomRewardStatus.Hidden : CustomRewardStatus.Active
    }
  })
  const teamNames = customReward.regions?.map((region) => teamName(region)).join(", ")
  const previewData = [
    {
      label: "admin.customRewards.create.lbl.rewardTitle",
      value: customReward.title
    },
    {
      label: "admin.customRewards.create.lbl.locations",
      value: teamNames || intl.formatMessage({id: "platform.lbl.all"})
    },
    {
      label: "admin.customRewards.create.lbl.policy",
      value: customReward.policy
    },
    {
      label: "admin.customRewards.create.lbl.redemption",
      value: customReward.redemptionInstructions
    }
  ]
  return (
    <>
      <Flex gap={2} alignItems="center">
        <Body width="15%">{customReward.title}</Body>
        {!customReward.regions && (
          <Body>
            <FormattedMessage id="platform.lbl.all" />
          </Body>
        )}
        {teamNames && <Body>{teamNames}</Body>}
        <Flex gap={1} flex="1" justifyContent="flex-end">
          <Button onClick={() => setShowPreview(true)}>
            <FormattedMessage id="platform.btn.viewDetails" />
          </Button>
          <ButtonRouterLink to={SETTINGS_CUSTOM_REWARDS_EDIT.replace(":uuid", customReward.uuid)}>
            <FormattedMessage id="platform.btn.edit" />
          </ButtonRouterLink>
          <Toggle icons={false} checked={customReward.status === CustomRewardStatus.Active} onClick={() => updateStatus()} />
        </Flex>
      </Flex>
      {customReward.status !== CustomRewardStatus.Active && (
        <Body small marginTop={1} color={theme.colors.greys.grey50}>
          <FormattedMessage id="admin.customReward.lbl.customRewardNotVisible" />
        </Body>
      )}
      <Hr />
      <GenericModal show={showPreview} onHide={() => setShowPreview(false)} hideActions>
        <Flex gap={3} direction="column">
          <H2>
            <FormattedMessage id="admin.customReward.preview.title" />
          </H2>
          {previewData.map(({label, value}) => (
            <Flex gap={1} direction="column">
              <H4>
                <FormattedMessage id={label} />
              </H4>
              <Body small>{value}</Body>
            </Flex>
          ))}
        </Flex>
      </GenericModal>
    </>
  )
}
export default CustomRewardItem
